import { axios } from "@/utils/axios-wrapper"
import { WalletResponse } from "models/general"
import { createContext, useContext } from "react"
import { useQuery } from "react-query"
import { useClientAuth } from "./client-auth"

export interface WalletContextValue {
	wallet: WalletResponse | null
}

export const WalletContext =
	createContext<WalletContextValue>({
		wallet: null,
	})

interface WalletProviderProps {
	children: React.ReactNode
}

function fetchWallet() {
	return async function (): Promise<WalletResponse> {
		const result = await axios
			.get<WalletResponse>("/api/v1/wallet/balance")
			.then((res) => res.data)

		return result
	}
}

export function WalletProvider(props: WalletProviderProps) {
	const { children } = props
	const { userInfo } = useClientAuth()

	const query = useQuery({
		queryKey: ["wallet", "user", userInfo?.userId],
		queryFn: fetchWallet(),
		enabled: userInfo !== null,
	})

	return (
		<WalletContext.Provider
			value={{
				wallet: query.data ?? null,
			}}>
			{children}
		</WalletContext.Provider>
	)
}

export function useWallet(): WalletResponse | null {
	return useContext(WalletContext).wallet
}
